import React from "react";
import { Box, Typography } from "@mui/material";
import { dashboardStyles } from "../../../assets/MUIStyles/dashboard";

const SummaryCard = ({ title, value, circleColor, errorMessage = false }) => {
  return (
    <Box
      sx={{
        ...dashboardStyles.summaryCardContainer,
        border: errorMessage ? "1px solid red" : "1px solid #D1D9EF",
      }}
    >
      {errorMessage && (
        <div title="Some message will come here." className="card-error-cont">
          <span className="card-error-text">Account Balance Expired</span>
        </div>
      )}
      <Box
        className="flex-align-center"
        sx={{
          marginBottom: 1,
        }}
      >
        <Box
          sx={{
            ...dashboardStyles.summaryCard.summaryIndicator,
            background: circleColor,
          }}
        />
        <Typography className="font-14-lightgrey">{title}</Typography>
      </Box>
      <Typography className="font-16-700-grey">{value}</Typography>
    </Box>
  );
};

export default SummaryCard;
